export class UserSession {
    id: string;
    token: string;
    login: string;
    nom: string;
    acl_roles_id: string;
    acl_roles_libelle: string;
    identites_id: string;
    identite_roles: any;


    constructor(data?: any) {
        if (!data) {
            data = [];
        }

        this.id                     = data['id'] ? data['id'] : null;
        this.token                  = data['token'] ? data['token'] : null;
        this.login                  = data['login'] ? data['login'] : null;
        this.nom                    = data['nom'] ? data['nom'] : null;
        this.acl_roles_id           = data['acl_roles_id'] ? data['acl_roles_id'] : null;
        this.acl_roles_libelle      = data['acl_roles_libelle'] ? data['acl_roles_libelle'] : null;
        this.identites_id           = data['identites_id'] ? data['identites_id'] : null;
        this.identite_roles         = data['identite_roles'] ? data['identite_roles'] : null;
    }
}
